export const USER_ADDRESS_STORAGE = "user:addresses";
export const USER_FAVORITES_STORAGE = "user:favorites";
export const USER_ORDERS_STORAGE = "user:orders";
export const USER_ACCOUNT_STORAGE = "user:account";
export const USER_SECRET_STORAGE = "user:secrets";
export const USER_PREFERRED_ADDRESS_STORAGE = "user:addresses:preferred";
export const USER_PREFERRED_DELIVERY_STORAGE = "user:delivery:preferred";
export const CUSTOMER_DATA_STORAGE = "customer:data";



// WEBPACK FOOTER //
// ./src/app/constants/storage.ts